import { Control, Controller, useForm } from "react-hook-form";
import { Dialog } from "components/Dialog";
import { Button } from "components/Button";
import { useTranslation } from "react-i18next";
import { TextField } from "@mui/material";
import {
  WaterMeterAuthType,
  WaterMeterCommunicationType,
  WaterMeterLocationType,
  WaterMeterModelType,
  WaterMeterType,
} from "types/dto";
import { Select } from "components/Select";
import { SortObjectByPropName } from "utils/arrayTools";
import { Enum2Array } from "utils/enumTools";
import RegionAutoComplete from "components/SpecificAutoComplete/RegionAutoComplete";
import { useState } from "react";
import { TAddFormTypes } from "../index";

type TProps = {
  control: Control<TAddFormTypes>;
};

export function TypeStep(props: TProps) {
  const { control } = props;

  const { t } = useTranslation();

  return (
    <div className="flex flex-col w-full gap-y-3">
      <div className={"flex flex-col px-6 gap-y-3"}>
        <p className={"font-bold text-primary-80"}>
          {t("selectMeterModelType")}
        </p>
        <p>{t("selectMeterModelTypeDesc")}</p>
        <Controller
          name={"modelType"}
          control={control}
          rules={{
            required: true,
          }}
          render={({ field, fieldState: { error } }) => {
            return (
              <Select
                {...field}
                size="small"
                onChange={(e) => {
                  field.onChange(e?.value);
                }}
                className="w-1/2 mt-3"
                label={t("waterMeterType")}
                options={SortObjectByPropName(
                  Enum2Array(WaterMeterModelType),
                  "name"
                )}
                isError={!!error}
              />
            );
          }}
        />
      </div>
    </div>
  );
}
